'use strict';

module.exports = require('./Trigger');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.9.1@rc-trigger/lib/index.js
 ** module id = 36
 ** module chunks = 0 1
 **/